import React, { useEffect, useState } from 'react';
import { message, Popconfirm } from 'antd';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';
import { theme } from 'utils/style/theme';
import { ifyouPassApi } from 'apis/sales/ifyouPassApis';
import DefaultInput from 'components/input/DefaultInput';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import DefaultButton from 'components/button/DefaultButton';
import InputWrappingBox from 'components/container/InputWrappingBox';
import InputFlexBox from 'components/container/InputFlexBox';
import TextFlexBox from 'components/container/TextFlexBox';
/**
 * * 판맨 관리 - 이프유 / 원데이 패스 관리
 */

const IfyouPassListPage = () => {
  const [cookies] = useCookies();
  const authUpdate = JSON.parse(cookies?.managementAuth);
  const [datas, setDatas] = useState();

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    setDatas(
      datas.map((v) =>
        index === v.ifyou_pass_id ? { ...v, [name]: Number(value) } : v,
      ),
    );
  };

  const fetchData = async () => {
    const res = await ifyouPassApi.read();
    setDatas(res);
  };

  const handleSubmit = async () => {
    const res = await ifyouPassApi.update(datas);
    if (!res) {
      return false;
    }
    message.success('패스 혜택이 수정되었습니다.');
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DefaultLayout>
      <TableToolbar>
        <div />
        <Popconfirm
          title='수정하시겠습니까?'
          // disabled={cookies.loginAdmin.management_auth === 'select' ? true : false}
          onConfirm={handleSubmit}
        >
          <DefaultButton disabled={authUpdate}>수정하기</DefaultButton>
        </Popconfirm>
      </TableToolbar>
      <div className='full_grayBox intro'>
        <InputFlexBox>
          <InputWrappingBox left>
            <TextFlexBox style={{ marginBottom: '1.2rem' }}>
              <h6>이프유 패스 관리 </h6>
            </TextFlexBox>
            <UlList>
              <li>작품 대기 시간 없음</li>
              <li>게임 플레이 광고 없음</li>
              <li>
                <div>
                  <p>유료 선택지 할인</p>
                  <DefaultInput
                    name='selection_sale'
                    value={datas?.[0].selection_sale}
                    onChange={handleInputChange(1)}
                    type='number'
                    style={{ width: '10rem' }}
                  />
                  <span>%</span>
                </div>
              </li>
              <li>
                <div>
                  <p>스타 즉시 지급</p>
                  <DefaultInput
                    name='star_directly_count'
                    value={datas?.[0].star_directly_count}
                    onChange={handleInputChange(1)}
                    type='number'
                  />
                </div>
              </li>
              <li>
                <div>
                  <p>스타 매일 지급</p>
                  <DefaultInput
                    name='star_daily_count'
                    value={datas?.[0].star_daily_count}
                    onChange={handleInputChange(1)}
                    type='number'
                  />
                </div>
              </li>
            </UlList>
          </InputWrappingBox>
          <InputWrappingBox>
            <TextFlexBox style={{ marginBottom: '1.2rem' }}>
              <h6>원데이 패스 관리 </h6>
            </TextFlexBox>
            <UlList>
              <li>작품 대기 시간 없음</li>
              <li>게임 플레이 광고 없음</li>
              <li>선택지 힌트 무료</li>
              <li>리셋 무료</li>
              <li>
                <div>
                  <p>유료 선택지 할인</p>
                  <DefaultInput
                    name='selection_sale'
                    value={datas?.[1].selection_sale}
                    onChange={handleInputChange(2)}
                    type='number'
                    style={{ width: '10rem' }}
                  />
                  <span>%</span>
                </div>
              </li>
              {/* <tr>
                  <th style={{ width: '10rem' }}>스타 즉시 지급</th>
                  <td style={styleDisplayCenter}>
                    <DefaultInput
                      type="number"
                      name="star_directly_count"
                      value={datas?.star_directly_count}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ width: '10rem' }}>스타 매일 지급</th>
                  <td style={styleDisplayCenter}>
                    <DefaultInput
                      type="number"
                      name="star_daily_count"
                      value={datas?.star_daily_count}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr> */}
            </UlList>
          </InputWrappingBox>
        </InputFlexBox>
      </div>
    </DefaultLayout>
  );
};

export default IfyouPassListPage;

const UlList = styled.ul`
  margin-left: 1rem;
  /* width: 90%; */
  li {
    list-style-type: circle;
    div {
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
    }
    margin-bottom: 0.5rem;
    p {
      width: 7.5rem;
    }
    span {
      margin-left: 0.5rem;
    }
  }
  li,
  p {
    color: ${theme.colors.blue_7};
    font-size: 0.9rem;
    font-weight: 500;
  }
`;
